<template>
  <section class="form">
    <b-tabs type="is-toggle-rounded" class="px-2">
      <b-tab-item label="Upload Learners">
        <upload-learner></upload-learner>
      </b-tab-item>
      <b-tab-item label="Delete Project Admins">
        <remove-admins></remove-admins>
      </b-tab-item>
      <b-tab-item label="Import Wonde Learners">
        <wonde-view></wonde-view>
      </b-tab-item>
      <b-tab-item label="Archive Learners">
        <user-table v-bind:viewPage="'archive'"></user-table>
        <archive-file></archive-file>
      </b-tab-item>
      <b-tab-item label="Unarchive Learners">
        <unarchive-file></unarchive-file>
      </b-tab-item>
      <b-tab-item label="Update classes">
        <update-classes></update-classes>
      </b-tab-item>
      <b-tab-item label="Add Subject">
        <add-subject></add-subject>
      </b-tab-item>
      <b-tab-item label="Learner Reports">
        <learner-reports></learner-reports>
      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script>
import UploadLearnerComponentVue from "./UploadLearnerComponent.vue";
import BulkUpdateClassesComponentVue from "./BulkUpdateClassesComponent.vue";
import BulkUnarchiveLearnersComponentVue from "./BulkUnarchiveLearnersComponent.vue";
import BulkArchiveFileUploadComponentVue from "./BulkArchiveFileUploadComponent.vue";
import AddSubjectComponent from "./AddSubjectComponent.vue";
import BulkLearnerReportsComponentVue from "./BulkLearnerReportsComponent.vue";
import UserTableComponentVue from "@/modules/users/components/UsersTableComponent.vue";
import WondeImportComponentVue from "./WondeImportComponent.vue";
import RemoveProjectAdmins from "./RemoveProjectAdmins.vue";

export default {
  name: "BulkActionsComponent",
  components: {
    "user-table": UserTableComponentVue,
    "upload-learner": UploadLearnerComponentVue,
    "update-classes": BulkUpdateClassesComponentVue,
    "archive-file": BulkArchiveFileUploadComponentVue,
    "unarchive-file": BulkUnarchiveLearnersComponentVue,
    "add-subject": AddSubjectComponent,
    "learner-reports": BulkLearnerReportsComponentVue,
    "wonde-view": WondeImportComponentVue,
    "remove-admins": RemoveProjectAdmins
  }
};
</script>
